import React from 'react';
import { withFormik } from 'formik';
import { editMomDiary, addMomDiary } from '../../services/';
import { toast } from 'react-toastify'
import MomDiaryForm from './MomDiaryForm'

const EnhancedMomDiary = withFormik({
  enableReinitialize: true,
  mapPropsToValues: (props) => ({
    recordId: props.recordId || '',
    title: props.title || '',
    content: props.content || '',
    mood: props.mood || '',
    files: [],
    childId: props.childId,
    formType: props.formType,
    documentFiles: props.files || []
  }),
  mapPropsToStatus: (props) => ({
    uploadedFiles: props.files || []
  }),
  handleSubmit: async (values) => {
    let formData = new FormData();
    for(let file of values.files) {
      formData.append("files", file);
    }

    formData.append("data", JSON.stringify(values));

    // const config = {
    //   headers: {
    //     "Content-Type": "multipart/form-data"
    //   }
    // };

    if(values.formType == "add") {
      const response = await addMomDiary(formData);
      toast.success("Your entry is successfully added");

    } else if(values.formType == "edit") {
      const response = await editMomDiary(formData);
      toast.success("Your diary is successfully updated");
    }



    // axios.post(process.env.REACT_APP_APIHOST + "/users/momdiary", formData, config)
    //   .then((res) => {

    //   })

  }
})(MomDiaryForm);

EnhancedMomDiary.defaultProps = {
  title: '',
    content: '',
    mood: '',
    files: [],
    childId: '',
    formType: 'add'
}

export default EnhancedMomDiary;



// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/MomDiary/EnhancedMomDiary.js